import {Leads, LinkButton, Text} from '@yandex-delivery/blocks'
import React from 'react'
import type {ButtonItem} from 'src/api'
import {tagToUrl} from 'src/shared/utils'

import {TextItem} from '../text-item'
import {classes} from './Payment.styles'
import {usePaymentButton} from './PaymentButton.hooks'

type Props = {
  item: ButtonItem
  url: string
}

export function PaymentButton({item, url}: Props): React.ReactElement {
  const {enabled, title, lead_icon: leadIcon, subtitle} = item
  const goToPaymentPage = usePaymentButton()

  return (
    <LinkButton
      alignItems="center"
      disabled={!enabled}
      fullWidth
      // @ts-expect-error тут тоже хендлеру нужен ивент. надо отрефакторить
      href={url}
      newTab
      onClick={goToPaymentPage}
      variant="action"
    >
      {leadIcon && (
        <Leads.Icon>
          <img alt="" className={classes.icon} data-theme-invert loading="lazy" src={tagToUrl(leadIcon.image_tag)} />
        </Leads.Icon>
      )}
      <Text align="center">
        <TextItem item={title} />
        {subtitle && <TextItem item={subtitle} />}
      </Text>
    </LinkButton>
  )
}
